import s from './MarketingModalMini.module.scss';
import { useEffect, useState } from 'react';
import {ReactComponent as CloseIcon} from "../../../assets/icons/close.svg"
import { MarketingModalButton } from './MarketingModalButton/MarketingModalButton';
import { useWindowSize } from 'utils/hooks/useWindowSize';
const image = "https://back.successwellnesscoaching.com//storage/files/429ffe87e7bbd0075b96a5e2f1eaed7392ebb72a.jpg"

export const MarketingModalMini = ({title, description, image, button}: any) => {

    // ### State
    const [show, setShow] = useState(true)
    const width = useWindowSize().width

    // ### Effects

    // ### Functions
   
    // ### Views

    return(
        <div className={s.modal}>
            <div className={s.left} style={{ 
                backgroundImage: `url(${image})`
            }}>
                <div className={s.close_wrapper} onClick={() => setShow(false)}>
                    <CloseIcon/>
                </div>
            </div>
            <div className={s.right}>

                <div className={s.close_wrapper} onClick={() => setShow(false)}>
                    <CloseIcon/>
                </div>

                <div className={s.content}>
                    <p className={s.title} dangerouslySetInnerHTML={{__html: title}}></p>
                    <p className={s.description} dangerouslySetInnerHTML={{__html: description}}></p>
                    <div className={s.button_wrapper}>
                        <MarketingModalButton
                            styles={{width: "100%"}}
                            title={button}
                            onClick={() => {}}
                        />
                    </div>
                </div>

            </div>
        </div>
    )
}